module.exports = __webpack_public_path__ + "static/media/Evil Knight.1472f1ac.jpg";